import FallingPetals from '@/components/FallingPetals.vue';

export default {
  name: "HomePage",
  data() {
    return {
      galleryImages: [
        '/path/to/image1.jpg',
        '/path/to/image2.jpg',
        '/path/to/image3.jpg',
        '/path/to/image4.jpg',
        '/path/to/image5.jpg',
        '/path/to/image6.jpg',
      ],
      lightboxOpen: false,
      currentImage: 0,
      currentSlide: 0,
      itemsToShow: 3,
      touchStartX: 0,
      touchEndX: 0
    };
  },
  components: {
    FallingPetals
  },
  computed: {
    slideCount() {
      return Math.ceil(this.galleryImages.length / this.itemsToShow);
    }
  },
  methods: {
    updateItemsToShow() {
      if (window.innerWidth <= 576) {
        this.itemsToShow = 1;
      } else if (window.innerWidth <= 992) {
        this.itemsToShow = 2;
      } else {
        this.itemsToShow = 3;
      }
      this.currentSlide = Math.min(this.currentSlide, this.galleryImages.length - this.itemsToShow);
    },
    prevSlide() {
      this.currentSlide = Math.max(0, this.currentSlide - this.itemsToShow);
    },
    nextSlide() {
      const max = this.galleryImages.length - this.itemsToShow;
      this.currentSlide = Math.min(max, this.currentSlide + this.itemsToShow);
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    openGallery(index) {
      this.currentImage = index;
      this.lightboxOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeLightbox() {
      this.lightboxOpen = false;
      document.body.style.overflow = '';
    },
    prevImage() {
      this.currentImage = (this.currentImage - 1 + this.galleryImages.length) % this.galleryImages.length;
    },
    nextImage() {
      this.currentImage = (this.currentImage + 1) % this.galleryImages.length;
    },
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    },
    handleSwipe() {
      if (this.lightboxOpen) {
        if (this.touchEndX < this.touchStartX - 50) this.nextImage();
        if (this.touchEndX > this.touchStartX + 50) this.prevImage();
      } else {
        if (this.touchEndX < this.touchStartX - 50) this.nextSlide();
        if (this.touchEndX > this.touchStartX + 50) this.prevSlide();
      }
    },
    handleKeyDown(e) {
      if (this.lightboxOpen) {
        if (e.key === 'ArrowLeft') this.prevImage();
        else if (e.key === 'ArrowRight') this.nextImage();
        else if (e.key === 'Escape') this.closeLightbox();
      } else {
        if (e.key === 'ArrowLeft') this.prevSlide();
        else if (e.key === 'ArrowRight') this.nextSlide();
      }
    }
  },
  mounted() {
    this.updateItemsToShow();
    window.addEventListener('resize', this.updateItemsToShow);
    window.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('touchstart', this.handleTouchStart);
    document.addEventListener('touchend', this.handleTouchEnd);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateItemsToShow);
    window.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchend', this.handleTouchEnd);
  }
};